import Vue from 'vue';
import VueRouter from 'vue-router';

import routes from './routes';
import store from '../store';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Wenn Portal';
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const username = sessionStorage.getItem('username');
    if (username && !store.state.auth.username)
      store.dispatch('auth/setUserDetails', { username });
    store.state.auth.username
      ? next()
      : next({
          name: 'Login',
          query: { redirect: to.fullPath }
        });
  } else {
    next();
  }
});

export default router;
